import { render, staticRenderFns } from "./SwitchLine.vue?vue&type=template&id=ab63ad28"
import script from "./SwitchLine.vue?vue&type=script&lang=js"
export * from "./SwitchLine.vue?vue&type=script&lang=js"
import style0 from "./SwitchLine.vue?vue&type=style&index=0&id=ab63ad28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports